export default __webpack_public_path__ + "static/media/TFNjekE4xm4-SD.54960387.jpg";